import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=7b4f7fe4&scoped=true&"
import script from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewSearch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NewSearch.vue?vue&type=style&index=0&id=7b4f7fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f7fe4",
  null
  
)

export default component.exports